import { type ValidatorFn, Validators } from '@angular/forms';

export class CloudValidators {
    public static exactLength(length: number): ValidatorFn[] {
        return [Validators.minLength(length), Validators.maxLength(length)];
    }
}
